import { render, staticRenderFns } from "./header-logo.vue?vue&type=template&id=2d355463&scoped=true&"
import script from "./header-logo.vue?vue&type=script&lang=js&"
export * from "./header-logo.vue?vue&type=script&lang=js&"
import style0 from "./header-logo.vue?vue&type=style&index=0&id=2d355463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d355463",
  null
  
)

export default component.exports